import type { ReactNode } from 'react';
import { DemoStoreContext, useDemoStoreValue } from './DemoStore';

export function DemoStoreProvider({ children }: { children: ReactNode }) {
  const value = useDemoStoreValue();
  return <DemoStoreContext.Provider value={value}>{children}</DemoStoreContext.Provider>;
}
